/** Device form factor: all types, or Table / Tablet product lines. */
export const DEVICE_TAB_ITEMS = [
  { value: "all", label: "All" },
  { value: "table", label: "Table" },
  { value: "tablet", label: "Tablet" },
] as const;

/** Connection / DB status filter (API `deviceStatus`). */
export const DEVICE_STATUS_OPTIONS = [
  { value: "all", label: "All statuses" },
  { value: "online", label: "Online" },
  { value: "offline", label: "Offline" },
] as const;

/** Product form factors for Create device only (kiosk tablet vs touch table). */
export const DEVICE_PLATFORM_OPTIONS = [
  { value: "tablet", label: "Tablet" },
  { value: "table", label: "Table" },
] as const;

export const DEVICE_GROUP_OPTIONS = [
  { value: "all", label: "All groups" },
  { value: "ungrouped", label: "Ungrouped" },
] as const;

export type DeviceTypeTab = (typeof DEVICE_TAB_ITEMS)[number]["value"];
export type DeviceStatusFilter = (typeof DEVICE_STATUS_OPTIONS)[number]["value"];
export type DevicePlatformFilter = (typeof DEVICE_PLATFORM_OPTIONS)[number]["value"];
export type DeviceGroupFilter = (typeof DEVICE_GROUP_OPTIONS)[number]["value"];
